export default "__VITE_ASSET__BHreYnpo__"